import { SET_PAGE, SET_EVENT_PAGES, DELETE_PAGE } from '../actions/actionTypes';
import { arrToObj } from '../util';
import { parsePage } from '../util/page.util';

const pagesReducer = (state = {}, action) => {
	Object.freeze(state);
	const stateDup = { ...state };
	const { type, pages, page, pageID } = action;

	switch (type) {
		case SET_PAGE:
			stateDup[page.id] = parsePage(page);
			return stateDup;
		case DELETE_PAGE:
			delete stateDup[pageID];
			return stateDup;
		case SET_EVENT_PAGES:
			return arrToObj(pages, parsePage);
		default:
			return stateDup;
	}
};

export default pagesReducer;
